import { render, staticRenderFns } from "./EmailSendLimitModal.vue?vue&type=template&id=1aef0b03&scoped=true&"
import script from "./EmailSendLimitModal.vue?vue&type=script&lang=js&"
export * from "./EmailSendLimitModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailSendLimitModal.vue?vue&type=style&index=0&id=1aef0b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef0b03",
  null
  
)

export default component.exports